import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { OffensePlaySelection } from "./OffensePlaySelection";
import { OffenseRunLog } from "./OffenseRunLog";
import { OffensePassLog } from "./OffensePassLog";
import { OffenseTurnoverLog } from "./OffenseTurnoverLog";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PenaltyLog } from "../Components/PenaltyLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";

export const OffenseLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  const { clearSelections } = useLogger();
  const { offensePlayers } = useDepthChart();

  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Box>
        {/* Play Selection */}
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffensePlaySelection />
          </AccordionDetails>
        </Accordion>

        {/* Run Log */}
        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Run Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffenseRunLog />
          </AccordionDetails>
        </Accordion>

        {/* Pass Log */}
        <Accordion
          expanded={expandedAccordion === "pass-log"}
          onChange={handleAccordionChange("pass-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="pass-log-content"
            id="pass-log-header"
          >
            <Typography>Pass Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffensePassLog />
          </AccordionDetails>
        </Accordion>

        {/* Penalty Log */}
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={offensePlayers} />
          </AccordionDetails>
        </Accordion>

        {/* Turnover Log */}
        <Accordion
          expanded={expandedAccordion === "turnover-log"}
          onChange={handleAccordionChange("turnover-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="turnover-log-content"
            id="turnover-log-header"
          >
            <Typography>Turnover Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OffenseTurnoverLog />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};
